import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=06bad801&"
import script from "./Action.vue?vue&type=script&lang=js&"
export * from "./Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports